export default __webpack_public_path__ + "static/media/icon-sun.f3da52d1.svg";